/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AvailableWorkScheduleCollectionResponse as BackendCoreApiModelsAppBookingAvailableWorkScheduleCollectionResponse } from '../models/Backend/Core/Api/Models/App/Booking/available-work-schedule-collection-response';
import { ChangeBookingStateRequest as BackendCoreApiModelsAppBookingChangeBookingStateRequest } from '../models/Backend/Core/Api/Models/App/Booking/change-booking-state-request';
import { CreateWorkScheduleRequest as BackendCoreApiModelsAppBookingCreateWorkScheduleRequest } from '../models/Backend/Core/Api/Models/App/Booking/create-work-schedule-request';
import { DeleteWorkScheduleRequest as BackendCoreApiModelsAppBookingDeleteWorkScheduleRequest } from '../models/Backend/Core/Api/Models/App/Booking/delete-work-schedule-request';
import { PharmacistRatingRequest as BackendCoreApiModelsAppBookingPharmacistRatingRequest } from '../models/Backend/Core/Api/Models/App/Booking/pharmacist-rating-request';
import { RatingRequest as BackendCoreApiModelsAppBookingRatingRequest } from '../models/Backend/Core/Api/Models/App/Booking/rating-request';
import { UpdateWorkScheduleRequest as BackendCoreApiModelsAppBookingUpdateWorkScheduleRequest } from '../models/Backend/Core/Api/Models/App/Booking/update-work-schedule-request';
import { WorkScheduleCollectionResponse as BackendCoreApiModelsAppBookingWorkScheduleCollectionResponse } from '../models/Backend/Core/Api/Models/App/Booking/work-schedule-collection-response';
import { SimpleResponse as SharedKernelModelsSimpleResponse } from '../models/SharedKernel/Models/simple-response';

@Injectable({
  providedIn: 'root',
})
export class BookingBackendService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createWorkSchedule
   */
  static readonly CreateWorkSchedulePath = '/api/booking/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createWorkSchedule$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createWorkSchedule$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppBookingCreateWorkScheduleRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BookingBackendService.CreateWorkSchedulePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createWorkSchedule$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createWorkSchedule$Plain(params?: {
    body?: BackendCoreApiModelsAppBookingCreateWorkScheduleRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.createWorkSchedule$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createWorkSchedule$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createWorkSchedule$Json$Response(params?: {
    body?: BackendCoreApiModelsAppBookingCreateWorkScheduleRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BookingBackendService.CreateWorkSchedulePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createWorkSchedule$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createWorkSchedule$Json(params?: {
    body?: BackendCoreApiModelsAppBookingCreateWorkScheduleRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.createWorkSchedule$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation deleteWorkSchedule
   */
  static readonly DeleteWorkSchedulePath = '/api/booking/delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteWorkSchedule$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteWorkSchedule$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppBookingDeleteWorkScheduleRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BookingBackendService.DeleteWorkSchedulePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteWorkSchedule$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteWorkSchedule$Plain(params?: {
    body?: BackendCoreApiModelsAppBookingDeleteWorkScheduleRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.deleteWorkSchedule$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteWorkSchedule$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteWorkSchedule$Json$Response(params?: {
    body?: BackendCoreApiModelsAppBookingDeleteWorkScheduleRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BookingBackendService.DeleteWorkSchedulePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteWorkSchedule$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteWorkSchedule$Json(params?: {
    body?: BackendCoreApiModelsAppBookingDeleteWorkScheduleRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.deleteWorkSchedule$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation getAvailableWorkSchedule
   */
  static readonly GetAvailableWorkSchedulePath = '/api/booking/available-work-schedule';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAvailableWorkSchedule$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableWorkSchedule$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppBookingAvailableWorkScheduleCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BookingBackendService.GetAvailableWorkSchedulePath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppBookingAvailableWorkScheduleCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAvailableWorkSchedule$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableWorkSchedule$Plain(params?: {
  }): Observable<BackendCoreApiModelsAppBookingAvailableWorkScheduleCollectionResponse> {

    return this.getAvailableWorkSchedule$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppBookingAvailableWorkScheduleCollectionResponse>) => r.body as BackendCoreApiModelsAppBookingAvailableWorkScheduleCollectionResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAvailableWorkSchedule$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableWorkSchedule$Json$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppBookingAvailableWorkScheduleCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BookingBackendService.GetAvailableWorkSchedulePath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppBookingAvailableWorkScheduleCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAvailableWorkSchedule$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableWorkSchedule$Json(params?: {
  }): Observable<BackendCoreApiModelsAppBookingAvailableWorkScheduleCollectionResponse> {

    return this.getAvailableWorkSchedule$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppBookingAvailableWorkScheduleCollectionResponse>) => r.body as BackendCoreApiModelsAppBookingAvailableWorkScheduleCollectionResponse)
    );
  }

  /**
   * Path part for operation getMyWorkSchedule
   */
  static readonly GetMyWorkSchedulePath = '/api/booking/my-work-schedule';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMyWorkSchedule$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMyWorkSchedule$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppBookingWorkScheduleCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BookingBackendService.GetMyWorkSchedulePath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppBookingWorkScheduleCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getMyWorkSchedule$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMyWorkSchedule$Plain(params?: {
  }): Observable<BackendCoreApiModelsAppBookingWorkScheduleCollectionResponse> {

    return this.getMyWorkSchedule$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppBookingWorkScheduleCollectionResponse>) => r.body as BackendCoreApiModelsAppBookingWorkScheduleCollectionResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMyWorkSchedule$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMyWorkSchedule$Json$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppBookingWorkScheduleCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BookingBackendService.GetMyWorkSchedulePath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppBookingWorkScheduleCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getMyWorkSchedule$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMyWorkSchedule$Json(params?: {
  }): Observable<BackendCoreApiModelsAppBookingWorkScheduleCollectionResponse> {

    return this.getMyWorkSchedule$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppBookingWorkScheduleCollectionResponse>) => r.body as BackendCoreApiModelsAppBookingWorkScheduleCollectionResponse)
    );
  }

  /**
   * Path part for operation getPharmacyWorkSchedule
   */
  static readonly GetPharmacyWorkSchedulePath = '/api/booking/pharmacy-work-schedule';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPharmacyWorkSchedule$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPharmacyWorkSchedule$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppBookingWorkScheduleCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BookingBackendService.GetPharmacyWorkSchedulePath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppBookingWorkScheduleCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPharmacyWorkSchedule$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPharmacyWorkSchedule$Plain(params?: {
  }): Observable<BackendCoreApiModelsAppBookingWorkScheduleCollectionResponse> {

    return this.getPharmacyWorkSchedule$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppBookingWorkScheduleCollectionResponse>) => r.body as BackendCoreApiModelsAppBookingWorkScheduleCollectionResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPharmacyWorkSchedule$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPharmacyWorkSchedule$Json$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppBookingWorkScheduleCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BookingBackendService.GetPharmacyWorkSchedulePath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppBookingWorkScheduleCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPharmacyWorkSchedule$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPharmacyWorkSchedule$Json(params?: {
  }): Observable<BackendCoreApiModelsAppBookingWorkScheduleCollectionResponse> {

    return this.getPharmacyWorkSchedule$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppBookingWorkScheduleCollectionResponse>) => r.body as BackendCoreApiModelsAppBookingWorkScheduleCollectionResponse)
    );
  }

  /**
   * Path part for operation ratePharmacist
   */
  static readonly RatePharmacistPath = '/api/booking/rate-pharmacist';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ratePharmacist$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ratePharmacist$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppBookingPharmacistRatingRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BookingBackendService.RatePharmacistPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ratePharmacist$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ratePharmacist$Plain(params?: {
    body?: BackendCoreApiModelsAppBookingPharmacistRatingRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.ratePharmacist$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ratePharmacist$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ratePharmacist$Json$Response(params?: {
    body?: BackendCoreApiModelsAppBookingPharmacistRatingRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BookingBackendService.RatePharmacistPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ratePharmacist$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ratePharmacist$Json(params?: {
    body?: BackendCoreApiModelsAppBookingPharmacistRatingRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.ratePharmacist$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation ratePharmacy
   */
  static readonly RatePharmacyPath = '/api/booking/rate-pharmacy';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ratePharmacy$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ratePharmacy$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppBookingRatingRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BookingBackendService.RatePharmacyPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ratePharmacy$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ratePharmacy$Plain(params?: {
    body?: BackendCoreApiModelsAppBookingRatingRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.ratePharmacy$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ratePharmacy$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ratePharmacy$Json$Response(params?: {
    body?: BackendCoreApiModelsAppBookingRatingRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BookingBackendService.RatePharmacyPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ratePharmacy$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ratePharmacy$Json(params?: {
    body?: BackendCoreApiModelsAppBookingRatingRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.ratePharmacy$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation reserve
   */
  static readonly ReservePath = '/api/booking/reserve';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reserve$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  reserve$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppBookingChangeBookingStateRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BookingBackendService.ReservePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reserve$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  reserve$Plain(params?: {
    body?: BackendCoreApiModelsAppBookingChangeBookingStateRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.reserve$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reserve$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  reserve$Json$Response(params?: {
    body?: BackendCoreApiModelsAppBookingChangeBookingStateRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BookingBackendService.ReservePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reserve$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  reserve$Json(params?: {
    body?: BackendCoreApiModelsAppBookingChangeBookingStateRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.reserve$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation resign
   */
  static readonly ResignPath = '/api/booking/resign';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resign$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  resign$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppBookingChangeBookingStateRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BookingBackendService.ResignPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resign$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  resign$Plain(params?: {
    body?: BackendCoreApiModelsAppBookingChangeBookingStateRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.resign$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resign$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  resign$Json$Response(params?: {
    body?: BackendCoreApiModelsAppBookingChangeBookingStateRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BookingBackendService.ResignPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resign$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  resign$Json(params?: {
    body?: BackendCoreApiModelsAppBookingChangeBookingStateRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.resign$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation updateWorkSchedule
   */
  static readonly UpdateWorkSchedulePath = '/api/booking/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateWorkSchedule$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateWorkSchedule$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppBookingUpdateWorkScheduleRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BookingBackendService.UpdateWorkSchedulePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateWorkSchedule$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateWorkSchedule$Plain(params?: {
    body?: BackendCoreApiModelsAppBookingUpdateWorkScheduleRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.updateWorkSchedule$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateWorkSchedule$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateWorkSchedule$Json$Response(params?: {
    body?: BackendCoreApiModelsAppBookingUpdateWorkScheduleRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BookingBackendService.UpdateWorkSchedulePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateWorkSchedule$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateWorkSchedule$Json(params?: {
    body?: BackendCoreApiModelsAppBookingUpdateWorkScheduleRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.updateWorkSchedule$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

}
